import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-notfound',
  standalone: true,
  imports: [TranslateModule, ButtonModule, RouterModule],
  templateUrl: './notfound.component.html'
})
export class NotFoundComponent {

}